// Section 18: Festival policy. Once a year; costs 1 food per person and 2 wood; needs a common hall; happiness +10 for 2 seasons, trust +4.
// Default: config.policies.defaults.festival.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { hasBuilding, population } from '../../core/queries';
import { noChangeCost } from '../../core/content-helpers';
import { definePolicy } from '../../core/registry';

export function festival(config: Config) {
  return definePolicy({
    id: 'festival',
    label: 'Festival',
    section: 'S18',
    group: 'society',
    options: ['off', 'summer', 'autumn'],
    default: config.policies.defaults.festival,
    modifierTargets: ['happinessTarget'],
    modifiers(ctx, target) {
      const until = ctx.state.festival.activeUntilTurn;
      if (target.kind !== 'happinessTarget' || until === null || until < ctx.season.turn) return [];
      return [mod.add('policy:festival', config.festival.happiness, 'festival')];
    },
    changeCost: noChangeCost,
    affects(ctx, option) {
      if (option === 'off') return [{ key: 'policy.festival.off', params: {} }];
      const f = config.festival;
      return [
        {
          key: 'policy.festival.cost',
          params: { food: f.foodPerPerson * population(ctx.state), wood: f.wood, season: option },
        },
      ];
    },
    validate(ctx, option) {
      if (option === 'off' || hasBuilding(ctx.state, 'common-hall')) return null;
      return {
        path: 'policies.festival',
        code: 'policy_locked',
        message: 'Festivals need a common hall.',
      };
    },
  });
}
